module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/character-message-1@2x-fe25cad644a69f839ea4084c9087acaa.png";